import { render, staticRenderFns } from "./NewAppLink.vue?vue&type=template&id=b12e98fa"
import script from "./NewAppLink.vue?vue&type=script&lang=js"
export * from "./NewAppLink.vue?vue&type=script&lang=js"
import style0 from "./NewAppLink.vue?vue&type=style&index=0&id=b12e98fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports